/** Merge reportId / stageId / lobby into userData storage. */
export function persistUserDataIds({ reportId, stageId, lobby } = {}) {
  try {
    const raw =
      localStorage.getItem("userData") ||
      sessionStorage.getItem("userData") ||
      "{}";
    const parsed = JSON.parse(raw) || {};
    const merged = {
      ...parsed,
      ...(reportId != null && String(reportId).trim() !== ""
        ? { reportId: String(reportId).trim() }
        : {}),
      ...(stageId != null && String(stageId).trim() !== ""
        ? { stageId: String(stageId).trim() }
        : {}),
      ...(lobby != null && String(lobby).trim() !== ""
        ? { lobby: String(lobby).trim() }
        : {}),
    };
    localStorage.setItem("userData", JSON.stringify(merged));
    sessionStorage.setItem("userData", JSON.stringify(merged));
  } catch {
    // ignore storage failures
  }
}
